import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GlobalErrorType } from '~/enums';
import { CustomGlobalError, GlobalErrorState } from '~/Interfaces';

const globalErrorInitialState: GlobalErrorState = Object.freeze({
  hasError: false,
  errorType: GlobalErrorType.API_FAILURE,
  showBanner: false,
  showCardOfferBanner: false,
});

const globalErrorSlice = createSlice({
  name: 'globalError',
  initialState: globalErrorInitialState,
  reducers: {
    toggleGlobalErrorOn: (state, action: PayloadAction<GlobalErrorType>) => {
      state.hasError = true;
      state.errorType = action.payload;
    },
    toggleGlobalErrorOff: (state) => {
      state.hasError = false;
    },
    hideBanner: (state) => {
      state.showBanner = false;
    },
    hideCardOfferBanner: (state) => {
      state.showCardOfferBanner = false;
    },
    setCustomGlobalError: (state, action: PayloadAction<CustomGlobalError>) => {
      state.customGlobalError = action.payload;
    },
  },
});

export const {
  toggleGlobalErrorOn,
  toggleGlobalErrorOff,
  setCustomGlobalError,
} = globalErrorSlice.actions;

export default globalErrorSlice.reducer;
